<ion-header>
  <ion-toolbar color="secondary">
    @if (title) {
      <ion-buttons slot="start">
        <ion-back-button color="light" defaultHref="/home"></ion-back-button>
      </ion-buttons>
    }

    <ion-title color="light">
      {{ title }}
      @if (!href) {
        <ion-icon [name]="icon"></ion-icon>
      }
    </ion-title>

    @if (href) {
      <ion-buttons slot="end">
        <ion-button (click)="toggleFavorite($event)">
          <ion-icon
            [name]="isFavorite ? 'star' : 'star-outline'"
            [color]="isFavorite ? 'warning' : 'light'"
          ></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
